<script>
  import SidePanel from "../components/sidePanel/SidePanel.svelte";
  import SidePanelSplitter from "../components/sidePanel/SidePanelSplitter.svelte";
  import SidePanelLinkCard from "../components/sidePanel/SidePanelLinkCard.svelte";
  import { getAutoMpsProjectContext } from "./AutoMpsProjectContext.js";

  const ctx = getAutoMpsProjectContext()
  const projectId = $ctx.projectId
</script>

<div class="root">
  <SidePanel>
    <img src="/assets/logo_asprova.png" alt="logo asprova"/>
    <div style="font-weight: bold; font-size: 1.2rem;">
      Asprova AutoMPS
    </div>
    <SidePanelLinkCard
      href={`/auto-mps/projects/${projectId}/plans/new`}
      backgroundColor="#00468f"
      textColor="white"
      title="新しい計画を立てる"
    />
    <SidePanelSplitter />
    <SidePanelLinkCard
      href={`/auto-mps/projects/${projectId}`}
      title="ダッシュボード"
    />
    <SidePanelLinkCard
      href={`/auto-mps/projects/${projectId}/executions`}
      title="過去の実行一覧"
      caption="過去の実行とその結果"
      currentDeterminerFunc={currentPathname => currentPathname.startsWith(`/auto-mps/projects/${projectId}/executions`)}
    />
    <SidePanelLinkCard
      href={`/auto-mps/projects/${projectId}/settings`}
      title="設定"
      caption="定期実行の予約、インポートやエクスポート方法の設定など"
      iconSrc="/assets/icons/icon_setting_inactive.png"
    />
  </SidePanel>
  <div class="main">
    <slot/>
  </div>
</div>

<style>
  .root {
    display: flex;
    height: 100%;
    max-width: 100vw;
  }

  .main {
    flex: 1;
    min-width: 0;
    max-height: 100%;
    overflow-y: auto;
    scrollbar-width: thin;
    background-color: white;
  }
</style>
